import { compose } from 'redux';

import { FieldInputType } from 'constants/fields';
import { FieldType } from 'constants/formGenerator';
import { fillConfigFieldsWithKeys } from 'utils/loanManagement';

import { BorrowersTestIds } from '../../../../../Borrowers.testIds';

import { POA_DESIGNATION, POA_DESIGNATION_OPTIONS } from './POA.constants';
import { poaSectionStyles } from './POA.styles';

export const getPoaConfigFields = ({ entityId }) => ({
  poaName: {
    fieldId: 'powerOfAttorneyName',
    type: FieldType.INPUT,
    nameInModel: `[${entityId}].powerOfAttorney.name`,
    inputProps: {
      placeholder: '-',
      label: 'POA Name',
      disabled: false,
      required: false,
      variant: 'outlined',
      dataTestId: BorrowersTestIds.POA_FORM_POA_NAME_INPUT,
      'data-test-value': 'poa-name',
    },
  },
  poaDesignation: {
    fieldId: 'powerOfAttorneyDesignation',
    type: FieldType.SELECT,
    nameInModel: `[${entityId}].powerOfAttorney.designation`,
    inputProps: {
      placeholder: '-',
      label: 'POA Designation',
      disabled: false,
      required: false,
      variant: 'outlined',
      options: POA_DESIGNATION_OPTIONS,
      dataTestId: BorrowersTestIds.POA_FORM_POA_DESIGNATION_SELECT,
      'data-test-value': POA_DESIGNATION.Agent,
    },
  },
  poaVerbiage: {
    fieldId: 'powerOfAttorneyVerbiage',
    type: FieldType.INPUT,
    nameInModel: `[${entityId}].powerOfAttorney.verbiage`,
    inputProps: {
      placeholder: '-',
      label: 'POA Verbiage',
      disabled: false,
      required: false,
      multiline: true,
      rows: 8,
      maxLength: 1000,
      variant: 'outlined',
      dataTestId: BorrowersTestIds.POA_FORM_POA_VERBIAGE_INPUT,
      'data-test-value': 'poa-verbiage',
    },
  },
  poaEmail: {
    fieldId: 'powerOfAttorneyEmail',
    type: FieldType.INPUT,
    nameInModel: `[${entityId}].powerOfAttorney.email`,
    inputProps: {
      type: FieldInputType.EMAIL,
      placeholder: '-',
      label: 'POA Email',
      disabled: false,
      required: false,
      variant: 'outlined',
      dataTestId: BorrowersTestIds.POA_FORM_POA_EMAIL_INPUT,
      'data-test-value': 'attorney@example.com',
    },
  },
  poaPhone: {
    fieldId: 'powerOfAttorneyPhone',
    type: FieldType.TEL,
    nameInModel: `[${entityId}].powerOfAttorney.phone`,
    inputProps: {
      type: FieldInputType.TEL,
      autoComplete: 'tel',
      placeholder: '-',
      label: 'POA Phone',
      disabled: false,
      required: false,
      variant: 'outlined',
      dataTestId: BorrowersTestIds.POA_FORM_POA_PHONE_INPUT,
      'data-test-value': '731-222-2222',
    },
  },
});

export const getPoaConfig = compose(fillConfigFieldsWithKeys, ({ entityId, section }) => {
  const poaConfigFields = getPoaConfigFields({ entityId });

  return {
    groups: [
      {
        type: FieldType.GROUP,
        fields: [
          poaConfigFields.poaName,
          poaConfigFields.poaDesignation,
          poaConfigFields.poaVerbiage,
          poaConfigFields.poaEmail,
          poaConfigFields.poaPhone,
        ],
        key: `${entityId}-${section}-0`,
        customStyles: poaSectionStyles,
      },
    ],
  };
});
